(function () {
	const STORAGE_KEY = '__sf_theme_recently'

	const initInteractive = (box) => {
		try {
			colorSwatches()
		} catch (err) {}

		try {
			window.SliderWrapper?.init(box)
		} catch (err) {}
	}

	const applyFallbackLink = (box) => {
		const fallbackUrl = box.dataset.fallbackUrl
		if (!fallbackUrl) return

		const link = box.querySelector('[data-recently-viewed-link]')
		if (!link || link.hasAttribute('href')) return

		link.setAttribute('href', fallbackUrl)
		link.removeAttribute('aria-disabled')
	}

	const showFallback = (box) => {
		if (box.dataset.hasFallback !== 'true') return false

		box.classList.remove('recently-viewed--empty')
		box.classList.add('recently-viewed--fallback')
		applyFallbackLink(box)
		initInteractive(box)
		return true
	}

	const hideSection = (section, box) => {
		box.classList.add('recently-viewed--empty')

		if (window.Shopify?.designMode) return

		section.hidden = true
	}

	const showEmptyState = (section, box) => {
		if (showFallback(box)) return
		hideSection(section, box)
	}

	const initSection = async (section) => {
		if (!section || !section.classList.contains('recently-viewed-section')) {
			return
		}

		section.hidden = false

		const box = section.querySelector('.recently-viewed')
		if (!box) return

		const EXPIRATION_DAYS = box.dataset.expirationDays
			? Number(box.dataset.expirationDays)
			: 30
		const dateNow = Date.now()

		const baseUrl = box.dataset.baseUrl
		const productsLimit = Number(box.dataset.productsLimit) || 6
		const currentPageProductId = box.dataset.currentPageProductId

		let recentProducts = []
		try {
			recentProducts = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []
		} catch (e) {
			console.error(`Incorrect value in local storage for "${STORAGE_KEY}"`)
		}

		if (currentPageProductId) {
			recentProducts = recentProducts.filter(
				(item) => item.productId !== currentPageProductId
			)
		}

		const expirationTime = EXPIRATION_DAYS * 24 * 60 * 60 * 1000
		const validProducts = recentProducts.filter(
			(item) => dateNow - item.timestamp < expirationTime
		)
		const limitedProducts = validProducts.slice(0, productsLimit)
		const query = limitedProducts
			.filter((item) => item.productId)
			.map((item) => `id:${item.productId}`)
			.join('%20OR%20')

		if (!query) {
			showEmptyState(section, box)
			box.classList.remove('recently-viewed--loading')
			return
		}

		try {
			const response = await fetch(`${baseUrl}&q=${query}`)
			const html = await response.text()
			const parser = new DOMParser()
			const doc = parser.parseFromString(html, 'text/html')
			const sourceBox = doc?.querySelector('.recently-viewed')
			if (!sourceBox?.classList.contains('recently-viewed--search-perfomed')) {
				showEmptyState(section, box)
				return
			}
			box.innerHTML = sourceBox.innerHTML
			box.classList.remove('recently-viewed--empty', 'recently-viewed--fallback')
			initInteractive(box)
		} catch (error) {
			console.error('Failed to fetch recently viewed products:', error)
			showEmptyState(section, box)
		} finally {
			box.classList.remove('recently-viewed--loading')
		}
	}

	initSection(document.currentScript.parentElement)

	document.addEventListener('shopify:section:load', function (event) {
		initSection(event.target)
	})
})()
